import {View, Text, Image} from 'react-native';
import React from 'react';
import {styles} from './styles';
import {Images} from '../../../../constants/Images';
import ButtonComponent from '../../../../components/ButtonComponent/ButtonComponent';

const NoInfoAlert = ({getLimits, loadingLimit}) => {
  return (
    <View style={styles.container}>
      <View style={{flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'flex-start', width: '100%', gap: 10,}}>

      <Image
        source={Images.warningB}
        style={{
          width: 15,
          height: 15,
        }}
      />
      <Text
                style={{
                  fontSize: 12,
                  lineHeight: 16,
                  fontFamily: 'TCCC-UnityText Bold',
                  color: 'black',
                }}>Limite não encontrado</Text>
      </View>
      
      <Text
              style={{
                marginLeft: -3,
                marginTop: 10,
                marginBottom: 12,
                fontSize: 12,
                lineHeight: 16,
                fontFamily: 'TCCC-UnityHeadline Regular',
                color: 'black',
              }}>
        Houve uma falha ao buscar o seu limite. Clique aqui para tentar novamente.
      </Text>

      <ButtonComponent
        title={loadingLimit ? "Carregando..." : "Tentar Novamente"}
        width="100%"
        onPress={() => getLimits()}
        disabled={loadingLimit}
      />
    </View>
  );
};

export default NoInfoAlert;
